import React, { useState, useEffect } from 'react';
import { Grid, GridNoRecords, GridColumn as Column } from '@progress/kendo-react-grid';

import moment from 'moment';

import queryString from 'query-string';

import { process as kendoProcess } from '@progress/kendo-data-query';

import BobLoadingMask from '../../../components/BobLoadingMask';
import BobTableContextMenu from '../../../components/BobTableContextMenu';
import HtmlTooltip from '../../../components/HtmlTooltip/HtmlTooltip';
import { FaultToolTip } from '../../../helpers/faultToolTip';

import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import { getTimeZoneAbbr } from '../../../helpers/timezones';
import HealthInfoModal from '../Modals/HealthInfoModal';

import clsx from 'clsx';

import * as bobActions from '../../../actions/bobActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import * as ruleAction from '../../../actions/ruleActions';
import { kendoGridInlineStyling } from '../../../helpers/kendoGridInlineStyleHelper';
import classes from './FaultsPanel.module.css';
import { isEmpty } from 'lodash';

const staticColumnName = [
    {
        field: 'ruleName',
        title: 'Rule',
        type:  'string'
    },
    {
        field: 'issueTypesList',
        title: 'Issue Type',
        type:  'string'
    },
    {
        field: 'priority',
        title: 'Priority',
        type:  'string'
    },
    {
        field: 'faultsCount',
        title: 'Fault Count',
        type:  'number'
    },
    {
        field: 'currentStatus',
        title: 'Current Status',
        type:  'string'
    },
    {
        field: '',
        title: '',
        type:  'string'
    }
];

const initialDataState = {
    sort: [],
    take: 10,
    skip: 0
};

const FaultsPanel = ({
    activeNavCompany,
    bobLoading,
    companyInfo,
    dashboardEndTimeStamp,
    dashboardIsCurrentTimeStamp,
    dashboardTimeframeEnd,
    dashboardTimeframeStart,
    dashboardStartTimeStamp,
    desiredInterval,
    entityRules,
    faultHistory,
    faultHistoryMeta,
    faultSummary,
    fetchFaultHistory,
    fetchFaultSummary,
    fetchEntityRulesAndScores,
    fetchEntityRules,
    fetchRuleScoreKpis,
    fetchRuleDatails,
    fetchScoringData,
    history,
    isActive,
    refreshTab,
    setRefreshTab,
    selectedSensors,
    setFaultData,
    setSelectedRuleFromFaultsPage,
    targetNavEquipment,
    workbookModeEnabled,
    ...props
}) => {
    const [dataState, setDataState] = useState(initialDataState);
    const [take, setTake] = useState(10);
    const [pageable] = useState({ pageSizes: true });
    const [openRuleInfoModal, setOpenRuleInfoModal] = useState(false);
    const [moreDetails, setMoreDetails] = useState({});
    const [data, setData] = useState([]);
    const [dataColumns, setDataColumns] = useState([]);

    const queryValues = queryString.parse(history.location.search);

    useEffect(() => {
        const init = () => {
            const history = [...faultHistory];
            const summary = [...faultSummary];

            let updatedData = [];
            let columns = [];

            summary.forEach(item => {
                const match = history.find(x => x.ruleId === item.ruleId);
                const combinedItem = { ...item, ...match };
                updatedData.push(combinedItem);
            });

            const columnHeaders = faultHistoryMeta.columnHeaders;

            if (isEmpty(columnHeaders)) {
                columns.push({
                    field: moment.utc(history[0].faultHistory[0].startTime).format(),
                    title: moment(history[0].faultHistory[0].startTime).format('M/DD h:mm A'),
                    cell:  statusBar
                });
            } else {
                faultHistoryMeta.columnHeaders.forEach((x, index) => {
                    let column = {
                        field: x,
                        title: index % 5 === 0 ? moment(x).format('M/DD h:mm A') : '-1',
                        cell:  statusBar
                    };
                    columns.push(column);
                });
            }

            setDataColumns(columns);
            setData(updatedData);
        };

        if (!isEmpty(faultHistory) && !isEmpty(faultSummary)) {
            init();
        }
        else {
            setData([]);
        }
    }, [faultHistory, faultSummary]);

    useEffect(() => {
        if (!workbookModeEnabled) {
            initialDataState.take = take;
            setDataState(initialDataState);
        }
    }, [workbookModeEnabled]);

    useEffect(() => {
        const init = async () => {
            const index = getTimeframeIndex(dashboardTimeframeStart, dashboardTimeframeEnd);
            await fetchFaultHistory(activeNavCompany.id, queryValues.system, dashboardTimeframeStart, dashboardTimeframeEnd, index);
        };

        if (activeNavCompany.id && !isEmpty(faultHistoryMeta)) init();
    }, [dashboardTimeframeStart, dashboardTimeframeEnd]);
    
    useEffect(() => {
        setSelectedRuleFromFaultsPage({});
    }, []);
    
    useEffect(() => {
        const refresh = async () => {
            setFaultData({});
            let promises = [];
            const index = getTimeframeIndex(dashboardTimeframeStart, dashboardTimeframeEnd);
            promises.push(fetchFaultSummary(activeNavCompany.id, queryValues.system, dashboardStartTimeStamp, dashboardEndTimeStamp));
            promises.push(fetchFaultHistory(activeNavCompany.id, queryValues.system, dashboardTimeframeStart, dashboardTimeframeEnd, index));

            await Promise.all(promises.map(p => p.catch(err => err)));
            setRefreshTab('');
        };
        if (refreshTab) refresh();
    }, [refreshTab]);

    const getTimeframeIndex = (start, end) => {
        const startDifference = moment.duration(moment(start).seconds(0).milliseconds(0).diff(moment(dashboardStartTimeStamp).seconds(0).milliseconds(0)));

        const startHours = startDifference.asHours();
        let index = startHours / 4 >> 0;

        const diff = moment.duration(moment(end).seconds(0).milliseconds(0).diff(moment(start).seconds(0).milliseconds(0)));
        if (diff.asHours() > 4) index++;

        return index;
    };

    const sortByObject = (array, key) => {
        return array.sort((a, b) => {
            const itemA = a[key];
            const itemB = b[key];

            if (itemA < itemB) {
                return -1;
            }

            if (itemA > itemB) {
                return 1;
            }

            return 0;
        });
    };

    // render status bar inside columns
    const statusBar = props => {
        const { dataItem } = props;
        const faultTooltips = [];
        const failureTooltips = [];
        const zone = moment.tz.guess();

        if (dataItem.faultHistory) {
            // faultHistory should be in ascending order to match column name.
            const faultHistory = sortByObject(dataItem.faultHistory, 'startTime');
            let tooltip = { startTime: null, endTime: null, status: null };

            // build the array of tooltips
            if (faultHistory.length === 1) {
                const startTime = moment(faultHistory[0].startTime).valueOf();
                const endTime = moment(faultHistory[0].endTime).valueOf();
                tooltip = {
                    startTime: startTime,
                    endTime:   endTime,
                    status:    faultHistory[0].status
                };
                switch (faultHistory[0].status.toLowerCase()) {
                    case 'infault':
                    case 'failure':
                        faultTooltips.push(tooltip);
                        failureTooltips.push(tooltip);
                        break;
                    default:
                        break;
                }
            }
            else {
                let currentStatus = faultHistory[0].status;
                for (let i = 0; i < faultHistory.length; i++) {
                    if (i === 0 && (currentStatus === 'InFault' || currentStatus === 'Failure')) {
                        tooltip = {
                            startTime: moment(faultHistory[i].startTime).valueOf(),
                            endTime:   moment(faultHistory[i].endTime).valueOf(),
                            status:    currentStatus
                        };
                        currentStatus = faultHistory[i].status;
                        continue;
                    }
                    if (faultHistory[i].status === currentStatus && faultHistory[i].status.toLowerCase() !== 'ok') {
                        tooltip.endTime = moment(faultHistory[i].endTime).valueOf();
                        currentStatus = faultHistory[i].status;
                        if (i === faultHistory.length - 1) {
                            if (currentStatus === 'InFault') {
                                faultTooltips.push(tooltip);
                            }
                            else if (currentStatus === 'Failure') {
                                failureTooltips.push(tooltip);
                            }
                        }
                        continue;
                    }
                    if (currentStatus === 'InFault') {
                        faultTooltips.push(tooltip);
                    }
                    else if (currentStatus === 'Failure') {
                        failureTooltips.push(tooltip);
                    }
                    if (faultHistory[i].status === 'InFault' || faultHistory[i].status === 'Failure') {
                        tooltip = {
                            startTime: moment(faultHistory[i].startTime).valueOf(),
                            endTime:   moment(faultHistory[i].endTime).valueOf(),
                            status:    faultHistory[i].status
                        };
                        if (i === faultHistory.length - 1) {
                            if (faultHistory[i].status === 'InFault') {
                                faultTooltips.push(tooltip);
                            }
                            else if (faultHistory[i].status === 'Failure') {
                                failureTooltips.push(tooltip);
                            }
                        }
                    }
                    currentStatus = faultHistory[i].status;
                }
            }

            for (let i = 0; i < faultHistory.length; i++) {
                const nextStartTime = faultHistory[i + 1] ? faultHistory[i + 1].startTime : null;

                if (props.field >= faultHistory[i].startTime && props.field <= faultHistory[i].endTime) {
                    let defaultClass = classes.StatusBar;
                    let color =  classes.Low;

                    if (props.field === faultHistory[i].endTime && nextStartTime === faultHistory[i].endTime) {
                        defaultClass = classes.StatusBar;
                    } else if (props.field === faultHistory[i].startTime) {
                        defaultClass = classes.StatusBarStart;
                    } else if (props.field === faultHistory[i].endTime) {
                        defaultClass = classes.StatusBarEnd;
                    }

                    if (faultHistory[i].status === 'Failure') {
                        color = classes.Failed;
                    } else if (faultHistory[i].status === 'OK') {
                        color = classes.Ok;
                    } else if (dataItem.priority === 'Medium') {
                        color = classes.Medium;
                    } else if (dataItem.priority === 'High') {
                        color = classes.High;
                    }

                    let toolTipText = '';
                    if (faultHistory[i].status === 'InFault') {
                        const epochStart = moment(faultHistory[i].startTime).valueOf();
                        const epochEnd = moment(faultHistory[i].endTime).valueOf();
                        const tt = faultTooltips.find(f => moment(epochStart).isSameOrAfter(moment(f.startTime)) && moment(epochEnd).isSameOrBefore(moment(f.endTime)));
                        if (tt) {
                            const startTimeText = moment(tt.startTime).format('YYYY-MM-DD h:mm A') + ' ' + getTimeZoneAbbr(moment(tt.startTime), zone);
                            const endTimeText = moment(tt.endTime).format('YYYY-MM-DD h:mm A') + ' ' + getTimeZoneAbbr(moment(tt.endTime), zone);
                            const displayStatus = tt.status === 'InFault' ? 'In Fault' : tt.status;
                            toolTipText = FaultToolTip(startTimeText, endTimeText, displayStatus, classes.ToolTip);
                        }
                        else {
                            toolTipText = faultHistory[i].status;
                        }
                    }
                    else if (faultHistory[i].status === 'Failure') {
                        const epochStart = moment(faultHistory[i].startTime).valueOf();
                        const epochEnd = moment(faultHistory[i].endTime).valueOf();
                        const tt = failureTooltips.find(f => moment(epochStart).isSameOrAfter(moment(f.startTime)) && moment(epochEnd).isSameOrBefore(moment(f.endTime)));
                        if (tt) {
                            const startTimeText = moment(tt.startTime).format('YYYY-MM-DD h:mm A') + ' ' + getTimeZoneAbbr(moment(tt.startTime), zone);
                            const endTimeText = moment(tt.endTime).format('YYYY-MM-DD h:mm A') + ' ' + getTimeZoneAbbr(moment(tt.endTime), zone);
                            const displayStatus = tt.status === 'InFault' ? 'In Fault' : tt.status;
                            toolTipText = FaultToolTip(startTimeText, endTimeText, displayStatus, classes.ToolTip);
                        }
                        else {
                            toolTipText = faultHistory[i].status;
                        }
                    }

                    return showStatusBar(faultHistory[i].status, toolTipText, defaultClass, color);
                }
            }
        }

        return (
            <td className={classes.StatusBarColumn} />
        );
    };

    const showStatusBar = (status, toolTipText, defaultClass, color) => {
        if (process.env.showFaultTooltip) {
            if (status !== 'OK') {
                return (
                    <td className={classes.StatusBarColumn}>
                        <HtmlTooltip
                            information={toolTipText}
                            placement="top-start"
                            body={ <div className={classes.StatusBarContainer}><div className={clsx(defaultClass, color)} /></div>}
                        />
                    </td>
                );
            }
            else {
                return (
                    <td className={classes.StatusBarColumn} />
                );
            }
        }
        else {
            return (
                <td className={classes.StatusBarColumn}>
                    <div className={clsx(defaultClass, color)} />
                </td>
            );
        }
    };

    const handleNameNavigation = dataItem => {
        let path = '/v2/dashboard/system';

        const queryValues = queryString.parse(history.location.search);

        queryValues.childId = '383849dd-bd20-4ee2-a0e5-1b192ddc4f81';
        queryValues.viewChildId = '4b25aeb8-45d4-4522-9f77-870ab40abb24';

        const queryValuesString = queryString.stringify(queryValues);

        return `${path}?${queryValuesString}`;
    };

    const handleNav = async dataItem => {
        let path = '/v2/dashboard/system';

        const queryValues = queryString.parse(history.location.search);

        queryValues.childId = '383849dd-bd20-4ee2-a0e5-1b192ddc4f81';
        queryValues.viewChildId = '4b25aeb8-45d4-4522-9f77-870ab40abb24';

        setSelectedRuleFromFaultsPage({
            ruleId:   dataItem.ruleId,
            ruleName: dataItem.ruleName
        });

        const queryValuesString = queryString.stringify(queryValues);
        history.push(`${path}?${queryValuesString}`);
    };

    const nameCell = props => {
        const styles = props.style;
        styles.padding = '10px 18px';

        return (
            <td className={props.className} style={styles}>
                <Link
                    to={handleNameNavigation(props.dataItem)}
                    onClick={
                        (e) => {
                            if (!e.ctrlKey) {
                                handleNav(props.dataItem);
                            }
                        }
                    }
                >
                    {props.dataItem[props.field]}
                </Link>
            </td>
        );
    };

    const staticColumn = props => {
        // we have to set className and styles to make this columns sticky
        // dynamically render priority icon
        const styles = props.style;
        styles.padding = '10px 18px';

        if (props.field === 'priority') {
            let imgPath = '/assets/images/low.svg';
            if (props.dataItem[props.field] === 'Medium') {
                imgPath = '/assets/images/medium.svg';
            } else if (props.dataItem[props.field] === 'High') {
                imgPath = '/assets/images/high.svg';
            }

            return (
                <td className={props.className} style={styles}>
                    <img className={classes.IconImage} src={imgPath} alt="" />
                    {props.dataItem[props.field]}
                </td>
            );
        }

        // dynamically render status icon
        if (props.field === 'currentStatus') {
            let imgPath = '/assets/images/okIconColor.svg';
            if (props.dataItem[props.field] === 'InFault') {
                imgPath = '/assets/images/inFaultIconColor.svg';
            } else if (props.dataItem[props.field] === 'Failure') {
                imgPath = '/assets/images/failedIconColor.svg';
            } else if (props.dataItem[props.field] === 'InActive') {
                imgPath = '/assets/images/disableIconRedColor.svg';
            }

            return (
                <td className={props.className} style={styles}>
                    <img className={classes.IconImage} src={imgPath} alt="" />
                    {props.dataItem[props.field]}
                </td>
            );
        }

        if (props.field === 'issueTypes') {
            return (
                <td className={props.className} style={styles} title={ props.dataItem[props.field]}>
                    { props.dataItem[props.field] }
                </td>
            );
        }

        if (props.field === 'faultHistory') {
            const { faultHistory } = props.dataItem;
            const faultCount = faultHistory.filter(fh => fh.status === 'InFault').length;
            let totalFaultCount = 0;
            if (faultHistory[0].status === 'InFault') {
                totalFaultCount = 1;
            }
            else {
                totalFaultCount = 0;
            }

            if (faultCount > 1) {
                let currentStatus = faultHistory[0].status;
                faultHistory.forEach(fault => {
                    if (fault.status !== currentStatus) {
                        if (fault.status === 'InFault') {
                            totalFaultCount++;
                        }
                    }
                    currentStatus = fault.status;
                });
            }
            else if (faultCount === 1) {
                totalFaultCount = 1;
            }

            return (
                <td className={props.className} style={styles}>
                    {totalFaultCount}
                </td>
            );
        }

        return (
            <td className={props.className} style={styles}>
                {props.dataItem[props.field]}
            </td>
        );
    };

    const staticColumnHeader = props => {
        return (
            <span className="k-link" onClick={props.onClick} role="none">
                <span className={classes.StaticColumnHeader}>
                    {props.title}
                </span>
                {props.children}
            </span>
        );
    };

    const actionsCell = props => {
        const styles = props.style;
        styles.paddingRight = '20px';

        return (
            <td className={props.className} style={props.style}>
                <BobTableContextMenu
                    type={'OpenRuleInfoModalFromFaultsPage'}
                    ruleData={props.dataItem}
                    setSelectedRule={(ruleData) => getRuleDetails(ruleData)}
                />
            </td>
        );
    };

    const faultHeaderCell = props => {
        let header;
        if (props.title !== '-1') {

            const split = props.title.split(' ');
            const date = split.shift();

            header = <React.Fragment>
                <div className={classes.Header}>
                    {date}
                </div>
                <div className={classes.Header}>
                    {split.join(' ')}
                </div>
            </React.Fragment >;
        } else {
            header = '';
        }

        return (
            <span>
                {header}
            </span>
        );
    };

    const getRuleDetails = async (rule) => {
        let details = await fetchRuleDatails(rule.ruleId);
        details.currentStatus = rule.currentStatus;
        setMoreDetails(details);
        setOpenRuleInfoModal(true);
    };

    const handleCloseRuleInfoModal = () => {
        setOpenRuleInfoModal(false);
        setMoreDetails({});
    };

    const onDataStateChange = e => {
        setTake(e.dataState.take);
        setDataState(e.dataState);
    };
    
    if (!isActive) return null;

    return (
        <div className={classes.Table}>
            <React.Fragment>
                <style>
                    { kendoGridInlineStyling }
                    {
                        `.k-grid th, .k-grid td {
                            padding: 10px 0 10px 5px
                        }
                        `
                    }
                </style>
                <Grid
                    sortable={{
                        mode: 'multiple'
                    }}
                    data={kendoProcess(data, dataState)}
                    {...dataState}
                    onDataStateChange={onDataStateChange}
                    className={classes.KendoGrid}   
                    filterable={workbookModeEnabled}
                    total={faultSummary.length}
                    pageable={pageable}
                    reorderable={false}
                >
                    {
                        bobLoading.includes('EntityRules') ?
                            <GridNoRecords>
                                Loading faults
                            </GridNoRecords>
                            :
                            <GridNoRecords>
                                No faults found
                            </GridNoRecords>
                    }
                    <Column
                        field={staticColumnName[0].field} title={staticColumnName[0].title} key={staticColumnName[0].field}
                        locked={true}
                        width={150}
                        cell={nameCell}
                        headerCell={staticColumnHeader}
                    />
                    <Column
                        field={staticColumnName[1].field} title={staticColumnName[1].title} key={staticColumnName[1].field}
                        locked={true}
                        width={150}
                        cell={staticColumn}
                        headerCell={staticColumnHeader}
                    />
                    <Column
                        field={staticColumnName[2].field} title={staticColumnName[2].title} key={staticColumnName[2].field}
                        locked={true}
                        width={115}
                        cell={staticColumn}
                        headerCell={staticColumnHeader}
                    />
                    <Column
                        field={staticColumnName[3].field} title={staticColumnName[3].title} key={staticColumnName[3].field}
                        locked={true}
                        width={115}
                        cell={staticColumn}
                        headerCell={staticColumnHeader}
                    />
                    <Column
                        field={staticColumnName[4].field} title={staticColumnName[4].title} key={staticColumnName[4].field}
                        locked={true}
                        width={135}
                        cell={staticColumn}
                        headerCell={staticColumnHeader}
                    />
                    <Column
                        field={staticColumnName[5].field} title={staticColumnName[5].title} key={staticColumnName[5].field}
                        locked={true}
                        sortable={false}
                        filterable={false}
                        width={75}
                        cell={actionsCell}
                        headerCell={staticColumnHeader}
                    />
                    {
                        dataColumns.map((column, index) => (
                            <Column
                                field={column.field} title={column.title} key={index}
                                width={60}
                                cell={column.cell}
                                sortable={false}
                                filterable={false}
                                headerCell={faultHeaderCell}
                            />
                        ))
                    }
                </Grid>
            </React.Fragment>
            {
                openRuleInfoModal ?
                    <HealthInfoModal
                        type={'RuleInfoModal'}
                        ruleDetails={moreDetails}
                        onCloseModal={() => { handleCloseRuleInfoModal(); }}
                    />
                    :
                    null
            }
            {
                bobLoading.includes('EntityRules') || bobLoading.includes('fetchRuleInfo') ?
                    <BobLoadingMask />
                    :
                    null
            }
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany:            state.bob.activeNavCompany,
        bobLoading:                  state.bob.bobLoading,
        companyInfo:                 state.companyInfo,
        faultHistory:                state.bob.faultHistory,
        faultHistoryMeta:            state.bob.faultHistoryMeta,
        faultSummary:                state.bob.faultSummary,
        faultSummaryMeta:            state.bob.faultSummaryMeta,
        targetNavEquipment:          state.bob.targetNavEquipment,
        dashboardEndTimeStamp:       state.dashboard.dashboardEndTimeStamp ? state.dashboard.dashboardEndTimeStamp.format() : null,
        dashboardStartTimeStamp:     state.dashboard.dashboardStartTimeStamp ? state.dashboard.dashboardStartTimeStamp.format() : null,
        dashboardTimeframeEnd:       state.dashboard.dashboardTimeframeEnd ? state.dashboard.dashboardTimeframeEnd.format() : null,
        dashboardTimeframeStart:     state.dashboard.dashboardTimeframeStart ? state.dashboard.dashboardTimeframeStart.format() : null,
        dashboardIsCurrentTimeStamp: state.dashboard.dashboardIsCurrentTimeStamp,
        desiredInterval:             state.dashboard.desiredInterval,
        entityRules:                 state.bob.entityRules,
        selectedSensors:             state.dashboard.selectedSensors
    };
};

const mapDispatchToProps = {
    ...bobActions,
    ...DashboardActions,
    ...ruleAction
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FaultsPanel));
